@if ((currentSite == 'seqirusb2b-flu360') || (userLoggedIn && userInfo?.webEnabled)) {
  <!--the above condition i gave becuase this should not relect in uk-Lo version-->
  @if (isLoading) {
    <div class="loading">
      <div class="loading_txt">
        <div class="load_txt">{{"helpnfaq.loading" | cxTranslate}}</div>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  }
  @if (!isLoading) {
    <div class="main helpnfaqcontainer" id="helpsection">
      @if (secondnode | async; as data) {
        <div class="help-faq-container">
          <div class="col-xs-12 help_searchheader">{{data.header1}}</div>
          <div class="col-xs-12 help_searchbar">
            <i class="fa fa-search" aria-hidden="true"></i>
            <input type="text" placeholder="Search frequently asked questions" id="help_searchbox"
              [(ngModel)]="searchvalue" (keydown.enter)="applyFilter(searchvalue)">
              <div id="help_searchbtn" (click)="applyFilter(searchvalue)">{{"helpnfaq.go_txt" | cxTranslate}}</div>
            </div>
            <!--when user searches something invalid-->
            @if (shownoresult) {
              <div>
                @if (secondnode | async; as data) {
                  <div class="col-xs-12 help_noresultsection">
                    <div class="help_noresultheader">{{data.subHeadLine}}</div>
                    <div class="help_noresultcontent" [innerHTML]="data.subContent"></div>
                  </div>
                }
              </div>
            }
            <!--code to give search results-->
            @if (searchresults && !shownoresult) {
              <div>
                <div class="col-xs-12 help_searchresults">{{"helpnfaq.searchResults" | cxTranslate}}</div>
                <div class="col-xs-12 search_accordion">
                  <div id="searchAccordion">
                    <div class="dropdown-item">
                      @for (item4 of filteredData; track item4; let i = $index) {
                        <div [ngClass]="{'show': issearchActive(i)}">
                          <div class="dropdown-outercontainer">
                            <button class="simple-dropdown-button" type="button" (click)="toggleSearchAccordion(i)">
                              <span class="accordion-text" [innerHTML]="item4.text2"></span>
                              <span class="arrow-icon">
                                <i class="fa-solid" [ngClass]="{'fa-chevron-down': !issearchActive(i), 'fa-chevron-up': issearchActive(i)}"></i>
                              </span>
                            </button>
                            <div id="collapse{{i}}" class="dropdown-content" [ngClass]="{'show': issearchActive(i)}">
                              <div class="dropdown-body">
                                @if (item4?.text1) {
                                  <div class="inline-div" [innerHTML]="item4?.text1"></div>
                                }
                                @if (item4?.title) {
                                  <div class="inline-div">
                                    &nbsp;
                                    <a (click)="openModal()">"{{item4?.title}}"
                                      <span class="linkbtton faBlack"><i class="fa fa-external-link"
                                      aria-hidden="true"></i></span>
                                    </a>
                                  </div>
                                }
                                <div class="inline-div help_searchsection" [innerHTML]="item4.content" appRouterlinkinterceptor></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            }
            <!--All accoerions appear at first and help button section-->
            @if (!shownoresult && !searchresults) {
              <div>
                <!--for us site the top images-->
                @if (currentSite == 'seqirusb2b-flu360') {
                  <div class="col-xs-12 help_sectionbtns">
                    <div class="helpsectionbtn" id="helpbtn_1" (click)="showAccordion(0, 'helpbtn_1')">
                      <div class="helpbtnicons" id="helpbtnicon1" role="img" aria-label="White general support gear icon">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.generalSupport" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_2" (click)="showAccordion(1, 'helpbtn_2')">
                      <div class="helpbtnicons" id="helpbtnicon2"></div>
                      <div class="active-class-div">{{"helpnfaq.createAccount" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_3" (click)="showAccordion(2, 'helpbtn_3')">
                      <div class="helpbtnicons" id="helpbtnicon3" role="img" aria-label="White orders icon"></div>
                      <div class="active-class-div">{{"helpnfaq.ordersnReturns" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_4" (click)="showAccordion(3, 'helpbtn_4')">
                      <div class="helpbtnicons" id="helpbtnicon4" role="img" aria-label="White dollar sign payment icon">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.paymentsnInvoice" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_5" (click)="showAccordion(4, 'helpbtn_5')">
                      <div class="helpbtnicons" id="helpbtnicon5" role="img"
                        aria-label="Products and information icon in white">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.productsnResources" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_6" (click)="showAccordion(5, 'helpbtn_6')">
                      <div class="helpbtnicons" id="helpbtnicon6" role="img"
                        aria-label="Person outline account icon in white">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.accountManagement" | cxTranslate}}</div>
                    </div>
                  </div>
                }
                <!-- for uk site the top images-->
                @if (currentSite == 'seqirusb2b-uk') {
                  <div class="col-xs-12 help_sectionbtns">
                    <div class="helpsectionbtn" id="helpbtn_1" (click)="showAccordion(0, 'helpbtn_1')">
                      <div class="helpbtnicons" id="helpbtnicon1" role="img" aria-label="White general support gear icon">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.generalSupport" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_3" (click)="showAccordion(1, 'helpbtn_3')">
                      <div class="helpbtnicons" id="helpbtnicon3" role="img" aria-label="White orders icon"></div>
                      <div class="active-class-div">{{"helpnfaq.ordersnReturns" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_4" (click)="showAccordion(2, 'helpbtn_4')">
                      <div class="helpbtnicons" id="helpbtnicon4" role="img" aria-label="White dollar sign payment icon">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.paymentsnInvoice" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_5" (click)="showAccordion(3, 'helpbtn_5')">
                      <div class="helpbtnicons" id="helpbtnicon5" role="img"
                        aria-label="Products and information icon in white">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.productsnResources" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_6" (click)="showAccordion(4, 'helpbtn_6')">
                      <div class="helpbtnicons" id="helpbtnicon6" role="img"
                        aria-label="Person outline account icon in white">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.accountManagement" | cxTranslate}}</div>
                    </div>
                    <div class="helpsectionbtn" id="helpbtn_8" (click)="showAccordion(5, 'helpbtn_8')">
                      <div class="helpbtnicons" id="helpbtnicon8" role="img"
                        aria-label="Person outline account icon in white">
                      </div>
                      <div class="active-class-div">{{"helpnfaq.medicalInformation" | cxTranslate}}</div>
                    </div>
                  </div>
                }
                <!--for us accordions-->
                @if (currentSite == 'seqirusb2b-flu360') {
                  <div class="col-xs-12 help_accordion">
                    <div id="faqDropdown">
                      @for (item2 of mergedObject1; track item2; let i = $index) {
                        <div [ngClass]="{'show': activeAccordion === null || activeAccordion === i}">
                          @if (activeAccordion === null || activeAccordion === i) {
                            <h3>{{item2.faqTitleType}}</h3>
                          }
                          @if (activeAccordion === null || activeAccordion === i) {
                            <div class="dropdown-item">
                              @for (item3 of mergedObject2; track item3; let j = $index) {
                                <div>
                                  @if (item3.parentId === item2.uid) {
                                    <div class="dropdown-outercontainer">
                                      <button class="simple-dropdown-button" [ngClass]="{'active': isActive(i, j)}"
                                        type="button" (click)="toggleDropdown(i, j)">
                                        <span class="accordion-text" [innerHTML]="item3.text2"></span>
                                        <span class="arrow-icon">
                                          <i class="fa-solid" [ngClass]="{'fa-chevron-down': !isActive(i, j), 'fa-chevron-up': isActive(i, j)}"></i>
                                        </span>
                                      </button>
                                      <div id="content{{i}}-{{j}}" class="dropdown-content"
                                        [ngClass]="{'show': isActive(i, j)}">
                                        <div class="outer-container dropdown-body">
                                          @if (item3?.text1) {
                                            <div class="inline-div" [innerHTML]="item3?.text1"></div>
                                          }
                                          @if (item3?.title) {
                                            <div class="inline-div">
                                              &nbsp;
                                              <a (click)="openModal()">"{{item3?.title}}"
                                                <span class="linkbtton faBlack"><i class="fa fa-external-link"
                                                aria-hidden="true"></i></span>
                                              </a>
                                            </div>
                                          }
                                          <div class="help_searchsection inline-div" [innerHTML]="item3.content" appRouterlinkinterceptor></div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (seallbtn) {
                        <div id="help_seeallsection" class="col-xs-12">
                          <button id="help_seeallbtn" (click)="sealltopics()">
                            {{"helpnfaq.seealltopics" | cxTranslate}}
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!--for uk accordions-->
                @if (currentSite == 'seqirusb2b-uk') {
                  <div class="col-xs-12 help_accordion">
                    <div id="faqDropdown">
                      @for (item2 of mergedObject1; track item2; let i = $index) {
                        <div [ngClass]="{'show': activeAccordion === null || activeAccordion === i}">
                          @if (activeAccordion === null || activeAccordion === i) {
                            <h3>{{item2.faqTitleType}}</h3>
                          }
                          @if (activeAccordion === null || activeAccordion === i) {
                            <div class="dropdown-item">
                              @for (item3 of mergedObject2; track item3; let j = $index) {
                                <div>
                                  @if (item3.parentId === item2.uid) {
                                    <div class="dropdown-outercontainer">
                                      <button class="simple-dropdown-button" [ngClass]="{'active': isActive(i, j)}"
                                        type="button" (click)="toggleDropdown(i, j)">
                                        <span class="accordion-text">{{item3.text2}}</span>
                                        <span class="arrow-icon">
                                          <i class="fa-solid" [ngClass]="{'fa-chevron-down': !isActive(i, j), 'fa-chevron-up': isActive(i, j)}"></i>
                                        </span>
                                      </button>
                                      <div id="content{{i}}-{{j}}" class="dropdown-content"
                                        [ngClass]="{'show': isActive(i, j)}">
                                        <div class="outer-container dropdown-body">
                                          @if (item3?.text1) {
                                            <div class="inline-div" [innerHTML]="item3?.text1"></div>
                                          }
                                          @if (item3?.title) {
                                            <div class="inline-div">
                                              &nbsp;
                                              <a (click)="openModal()">"{{item3?.title}}"
                                                <span class="linkbtton faBlack"><i class="fa fa-external-link"
                                                aria-hidden="true"></i></span>
                                              </a>
                                            </div>
                                          }
                                          <div class="help_searchsection inline-div" [innerHTML]="item3.content" appRouterlinkinterceptor></div>
                                        </div>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (seallbtn) {
                        <div id="help_seeallsection" class="col-xs-12">
                          <button id="help_seeallbtn" (click)="sealltopics()">
                            {{"helpnfaq.seealltopics" | cxTranslate}}
                          </button>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
    <!-- the following is for pop up for uk-->
    @if (popupdata) {
      <div>
        <div class="help_Faq_commonleaving_abandonedPop_Li modal  fade" [ngClass]="{'show': isModalOpen}" role="dialog"
          data-backdrop="static" data-keyboard="false" id="help_Faq_commonleaving_abandonedPop_Li" tabindex="-1">
          <div class="modal-body knowledgeHub_abandonedPopContent">
            <div class="knowledgeHub_abandonedPopHeader">
              <div class="knowledgeHub_abandonedPopTitle">{{popupdata.headline}}</div>
              <div class="knowledgeHub_abandonedPopClose" (click)="closeModal()">X</div>
              <div class="clearboth"></div>
            </div>
            <div class="knowledgeHub_abandonedPopText">
              <p [innerHTML]="popupdata.message1"></p>
              <p [innerHTML]="popupdata.message2"></p>
            </div>
            <div class="knowledgeHub_abandonedPopBtns">
              <a href="{{popupdata.link}}" target="_blank" class="knowledgeHub_abandonedPopBtn commonleave_popContBtn">{{popupdata.label1}}</a>
              <button class="knowledgeHub_abandonedPopBtn knowledgeHub_popCanceltBtn"
                (click)="closeModal()">{{popupdata.label2}}
              </button>
            </div>
            <div class="knowledgedocnumberUk">{{popupdata.jobBagCode}}</div>
          </div>
        </div>
      </div>
    }
  }